import React from 'react'
import { List, TextField } from 'react-admin'
import CommonDataGrid from '../common/DataGrid'

function NowOnlineList() {

  return (
  //   <List>
  //   <CommonDataGrid>
  //     <TextField source='id'/>
  //     <TextField source='first_name'/>
  //     <TextField source='last_name'/>
  //     <TextField source='email'/>
  //     <TextField source='last_activity'/>
  //     <TextField source='type'/>
  //   </CommonDataGrid>
  // </List>
  <div style={{ display: 'block' }}>
    <div style={{ marginTop: '5%', fontSize: '1.5rem', fontWeight: 700 }}>
      Now Online
    </div>
    <div>
      Temporary page ---- Resource missing!
    </div>
  </div>
  )
}
export default NowOnlineList